function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6667 0.666992H5.99333C5.26 0.666992 4.66667 1.26699 4.66667 2.00033H11.3333C12.0667 2.00033 12.6667 2.60033 12.6667 3.33366V12.0003L14 12.667V2.00033C14 1.26699 13.4 0.666992 12.6667 0.666992ZM10 4.66699V13.3137L7.19333 12.107L6.66667 11.8803L6.14 12.107L3.33333 13.3137V4.66699H10ZM3.33333 3.33366H10C10.7333 3.33366 11.3333 3.93366 11.3333 4.66699V15.3337L6.66667 13.3337L2 15.3337V4.66699C2 3.93366 2.6 3.33366 3.33333 3.33366Z"
});

var SvgBookmarks = function SvgBookmarks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmarks.5aa8dc98.svg";
export { ForwardRef as ReactComponent };